/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";
import "./ReservationList.css";
import { MaterialReactTable } from "material-react-table";
import Tooltip from "@mui/material/Tooltip";
import * as XLSX from "xlsx";
// import demodata =============================
import { Link } from "react-router-dom";
//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";
//import context
import { GlobalProvider } from "context/GlobalContext";
//import translation function for language translation
import { useTranslation } from "react-i18next";
import useAppMRT from "hooks/useAppMRT";
//import file download function
import downloadFileHandler from "helpers/DownloadFile";
import ViewReserveModal from "../Modal/ViewReserveModal";

const ReservationList = ({
  downloadExcel,
  columns,
  setColumns,
  setRecords,
  checkedRecordCount,
  handelClientSelect,
}) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { t } = useTranslation(); // translation
  const appMRTProps = useAppMRT();
  const {
    /*----- loading -----*/
    isReserveListLoading,
    setIsReserveListLoading,
    /*------ reload requirements start -------*/
    reloadReservationList,
    setReloadReservationList,
    /*------ reload requirements end -------*/
    /* -------- reload refresh start --------- */
    reloadRefresh,
    setReloadRefresh,
    /* -------- reload refresh end --------- */
    /*------ edit requirements start -------*/
    setEditReserveData,
    setChangeReserveEducatorData,
    setAllowSelectEducator,
    /*------ edit requirements end -------*/
    //for custom reseve
    setReserveIdNumber,
    setCustomReserveId,
    //for survey
    setReservePersonData,
    //for reserve emails
    setReservationEmailHistoryData,
    //for copy reseve data
    setCopyReserveData,
    //for consecutive
    setaddMoreConsecutiveReserveData,
    /*------ search requirements start -------*/
    searchReserveDate,
    searchReserveIdList,
    searchReserveAmbIdList,
    searchReserveActivity,
    searchReserveLabels,
    searchReserveBenificiaries,
    searchReserveClients,
    searchReserveExcludeClients,
    searchReserveEducators,
    searchReserveStatus,
    setSearchReserveDate,
    setSearchReserveIdList,
    setSearchReserveActivity,
    setSearchReserveLabels,
    setSearchReserveBenificiaries,
    setSearchReserveClients,
    setSearchReserveEducators,
    setSearchReserveStatus,
    isConsecutiveReserveFilter,
    setisConsecutiveReserveFilter,
    unsentMailReserveFilter,
    setUnsentMailReserveFilter,
    setReserveSurveyData,
    clientFeedbackEducatorData,
    setClientFeedbackEducatorData,
    /*------ search requirements end -------*/
    screenHeight,
    setSuccess,
    setNotificationString,
    setError,
  } = useContext(GlobalProvider);

  const [reservationList, setReservationList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [viewReserveData, setViewReserveData] = useState(null);
  const [defaultDateRange, setDefaultDateRange] = useState(null);
  //use state for adding css in table div
  const [searchContainerClass, setSearchContainerClass] = useState("");
  // Material React Table row selection state
  const [rowSelection, setRowSelection] = useState({});

  const openGoogleMaps = (location, zipcode) => {
    if (!location || !zipcode) {
      alert("Location or zipcode is missing.");
      return;
    }

    const query = encodeURIComponent(`${location}, ${zipcode}, España`);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${query}`;

    window.open(mapsUrl, "_blank", "noopener,noreferrer");
  };

  /* function for get all reservation */
  const getAllReservationList = async () => {
    try {
      setIsReserveListLoading(true);
      setAllowSelectEducator(true);
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_RESERVE_EVENTS + `?token=${token}`;
      if (searchReserveDate != "") {
        requestUrl = requestUrl + `&eventdate=${searchReserveDate}`;
      }
      if (searchReserveIdList.length > 0) {
        requestUrl = requestUrl + `&reserveids=${searchReserveIdList}`;
      }
      if (searchReserveAmbIdList.length > 0) {
        requestUrl = requestUrl + `&reserveambids=${searchReserveAmbIdList}`;
      }
      if (searchReserveActivity.length > 0) {
        requestUrl = requestUrl + `&reserveactivity=${searchReserveActivity}`;
      }
      if (searchReserveLabels.length > 0) {
        requestUrl = requestUrl + `&reservelabels=${searchReserveLabels}`;
      }
      if (searchReserveBenificiaries.length > 0) {
        requestUrl =
          requestUrl + `&reservebenificiary=${searchReserveBenificiaries}`;
      }
      if (searchReserveClients.length > 0) {
        requestUrl = requestUrl + `&reserveclients=${searchReserveClients}`;
      }
      if (searchReserveExcludeClients.length > 0) {
        requestUrl =
          requestUrl + `&reserveexcludeclients=${searchReserveExcludeClients}`;
      }
      if (searchReserveEducators.length > 0) {
        requestUrl = requestUrl + `&reserveeducators=${searchReserveEducators}`;
      }
      if (searchReserveStatus.length > 0) {
        requestUrl = requestUrl + `&reservestatus=${searchReserveStatus}`;
      }
      if (isConsecutiveReserveFilter) {
        requestUrl =
          requestUrl + `&isconsecutivereserve=${isConsecutiveReserveFilter}`;
      }
      if (unsentMailReserveFilter) {
        requestUrl = requestUrl + `&unsentmail=${unsentMailReserveFilter}`;
      }
      console.log("reserve list url =====>>>", requestUrl);
      const response = await getData(requestUrl);
      console.log("reserve list response ========>>>", response);

      if (response.status) {
        setIsReserveListLoading(false);
        setReservationList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
        if (response.resultStartDate && response.resultEndDate) {
          setDefaultDateRange({
            start: response.resultStartDate,
            end: response.resultEndDate,
          });
        } else {
          setDefaultDateRange(null);
        }
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* function to send mail to beneficiary */
  const mailToBeneficiary = async (dataItem) => {
    let recieversMailsArray = [];
    if (dataItem.beneficiaries && dataItem.beneficiaries.length > 0) {
      dataItem.beneficiaries.map((userData) => {
        recieversMailsArray.push(userData.email);
      });
    }
    if (dataItem.responsibles && dataItem.responsibles.length > 0) {
      dataItem.responsibles.map((userData) => {
        recieversMailsArray.push(userData.email);
      });
    }
    if (recieversMailsArray.length > 0) {
      const mailData = {
        reserve: dataItem._id,
        template: "reserve-info-beneficiary",
        receivermailarray: recieversMailsArray,
      };
      try {
        let requestUrl =
          url.API_BASEURL +
          url.API_SEND_MESSAGE_BY_TEMPLATE +
          `?token=${token}`;
        const response = await postData(requestUrl, mailData);
        if (response.status) {
          console.log(response);
          setNotificationString("Mail sent to beneficiary");
          setSuccess(true);
        }
      } catch (error) {
        console.error(error.message);
      }
    } else {
      setNotificationString(
        "No beneficiary/responsible associated with the reserve"
      );
      setSuccess(true);
    }
  };

  /* function to send mail to observer */
  const mailToObserver = async (dataItem) => {
    let observerMailsArray = [];
    if (dataItem.observers) {
      dataItem.observers.map((observerData) => {
        observerMailsArray.push(observerData.email);
      });
      const mailData = {
        reserve: dataItem._id,
        template: "reserve-info-beneficiary",
        receivermailarray: observerMailsArray,
      };
      try {
        let requestUrl =
          url.API_BASEURL +
          url.API_SEND_MESSAGE_BY_TEMPLATE +
          `?token=${token}`;
        const response = await postData(requestUrl, mailData);
        if (response.status) {
          setNotificationString("Mail sent to observers");
          setSuccess(true);
        }
      } catch (error) {
        console.error(error.message);
      }
    } else {
      setNotificationString("No observer associated with the reserve");
      setSuccess(true);
    }
  };

  //function for change reconfirmation
  const reConfirmHandler = async (e) => {
    const booleanToStringValue = e.target.checked.toString();
    let reserveData = {
      reconfirmation: booleanToStringValue,
    };
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_UPDATE_RESERVE_EVENT +
        `/${e.target.value}` +
        `?token=${token}`;
      const response = await putData(requestUrl, reserveData);
      if (response.status) {
        setReloadReservationList(true);
        setSuccess(true);
        setNotificationString(
          t("Reconfirmation has been updated successfully")
        );
      }
    } catch (error) {
      console.error(error.message);
      setError(true);
      setNotificationString(t("Something went wrong, please try again later"));
    }
  };

  // Get selected data using Material React Table's row selection
  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter(key => rowSelection[key]);
    const selectedRows = reservationList.filter(item => selectedIds.includes(item._id));
    return selectedRows;
  };

  // Excel export using xlsx
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData =
      selectedData.length > 0 ? selectedData : reservationList;

    const getFieldValue = (item, field) => {
      const parts = field.split(".");
      return parts.reduce((obj, key) => obj?.[key] ?? "", item) ?? "";
    };

    const columnFieldMap = {
      Shift: "shiftlabel",
      Date: "reservedate",
      Day: "reserveday",
      "Start Time": "starttime",
      "End Time": "endtime",
      Code: "activitycode.code",
      Activity: "activitycode.name",
      "Activity Type": "activitytype",
      Tags: "tagstring",
      "Educator 1": "educator1.name",
      "Educator 2": "educator2.name",
      Client: "client.name",
      Observer: "observer.name",
      Beneficiary: "beneficiary.name",
      Responsible: "responsible.name",
      "No of Participants": "participantcount",
      "No of Educator": "educatorcount",
      "No Participants Real": "realparticipantcount",
      Tutor: "tutor",
      "Specific Audience": "specificaudiencestring",
      Grade: "grade",
      "Sales Order": "salesorderstring",
      Comments: "comments",
      "Int. Comments": "internalcomment",
      Location: "location",
      Zipcode: "zipcode",
      Status: "reservestatus",
    };

    const defaultExportDefs = [
      { field: "customerid", title: t("ID") },
      { field: "isconsecutivestring", title: t("Is Consecutive") },
      { field: "shiftlabel", title: t("Shift") },
      { field: "ambreservationid", title: t("AMB Id") },
      { field: "reservedate", title: t("Date") },
      { field: "reserveday", title: t("Day") },
      { field: "starttime", title: t("Start Time") },
      { field: "endtime", title: t("End Time") },
      { field: "activitycode.code", title: t("Code") },
      { field: "activitycode.name", title: t("Activity") },
      { field: "activitytype", title: t("Activity Type") },
      { field: "tagstring", title: t("Tags") },
      { field: "educator1.name", title: t("Educator 1") },
      { field: "educator2.name", title: t("Educator 2") },
      { field: "client.name", title: t("Client") },
      { field: "observer.name", title: t("Observer") },
      { field: "beneficiary.name", title: t("Beneficiary") },
      { field: "responsible.name", title: t("Responsible") },
      { field: "participantcount", title: t("No of Participants") },
      { field: "educatorcount", title: t("No of Educator") },
      { field: "realparticipantcount", title: t("No Participants Real") },
      { field: "salesorderstring", title: t("Sales order") },
      { field: "tutor", title: t("Tutor") },
      { field: "specificaudiencestring", title: t("Specific Audience") },
      { field: "grade", title: t("Grade") },
      { field: "comments", title: t("Comments") },
      { field: "internalcomment", title: t("Internal Comments") },
      { field: "location", title: t("Location") },
      { field: "reservestatus", title: t("Status") },
    ];

    let exportDefs;
    if (columns.length > 0) {
      const selectedFields = new Set(
        columns.map((col) => columnFieldMap[col]).filter(Boolean)
      );
      exportDefs = [
        { field: "reserveid", title: t("ID") },
        { field: "isconsecutivestring", title: t("Is Consecutive") },
        ...defaultExportDefs.filter((d) => selectedFields.has(d.field)),
      ];
    } else {
      exportDefs = defaultExportDefs;
    }

    const rows = exportData.map((item) => {
      const row = {};
      exportDefs.forEach(({ field, title }) => {
        row[title] = getFieldValue(item, field);
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reservation List");
    XLSX.writeFile(wb, "Reservation List.xlsx");
  };

  // Material React Table handles row selection automatically
  // No need for custom checkbox components

  // Primary Block
  const primaryBlockHtml = ({ dataItem }) => {
    //check if logged in user is eductor
    const userIdEductor = dataItem?.educators?.find(
      (educator) => educator._id.toString() === userInfo._id.toString()
    );

    //function for download material
    const materialDownloadHandler = async () => {
      const uploads = dataItem?.activitycode?.uploads ?? [];

      console.log("uploads", uploads);

      const beneficiaryUploads =
        dataItem?.activitycode?.beneficiaryuploads ?? [];
      const mergedFiles = [...uploads, ...beneficiaryUploads];

      if (userInfo?.role?.name == "admin") {
        if (mergedFiles.length > 0) {
          for (const file of mergedFiles) {
            downloadFileHandler(file);
          }
        }
      } else if (userInfo?.role?.name == "educator") {
        if (uploads.length > 0) {
          for (const file of uploads) {
            downloadFileHandler(file);
          }
        }
      } else if (userInfo?.role?.name == "beneficiary") {
        if (beneficiaryUploads.length > 0) {
          for (const file of beneficiaryUploads) {
            downloadFileHandler(file);
          }
        }
      }
    };

    return (
      <div className="d-flex align-items-center gap-2">
        {/* ------- custom reserve id start ------- */}

        <p className="me-2 mb-0">
          {dataItem.customerid}{" "}
          {dataItem.isconsecutivereserve && (
            <span
              className="material-symbols-outlined icon-md text-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Consecutive reserve"
            >
              copyright
            </span>
          )}
        </p>
        {/* ------- custom reserve id end ------- */}

        {/* -------- action icons + dropdown grouped -------- */}
        <div className="ms-auto d-flex align-items-center gap-1">
          <Link
            to="#"
            className={`d-block material-symbols-outlined icon-md ${
              dataItem.zipcode ? "text-green" : "text-danger"
            }`}
            onClick={(e) => {
              e.preventDefault();

              const { location, zipcode } = dataItem;

              if (!location || !zipcode) {
                alert("No location or zipcode added.");
                return;
              }

              openGoogleMaps(location, zipcode);
            }}
          >
            location_on
          </Link>

          {/* --------- reserve history with icon start ---------- */}
          <Link
            to="#historyReservePopup"
            className="text-black"
            data-bs-toggle="offcanvas"
            role="button"
            aria-controls="historyReservePopup"
            onClick={() => {
              setReserveIdNumber(dataItem.reserveid);
            }}
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="History of modification"
            >
              history
            </span>
          </Link>
          {/* --------- reserve history with icon end ---------- */}
          {/* --------- edit reserve with icon start ---------- */}
          {userInfo?.role?.name == "admin" ||
          userInfo?.role?.name == "manager" ? (
            <Link
              to="#saveReservationPopup"
              data-bs-toggle="offcanvas"
              className="text-black"
              role="button"
              aria-controls="saveReservationPopup"
              onClick={() => {
                let editData = {
                  _id: dataItem?._id,
                  reserveid: dataItem?.reserveid,
                  customerid: dataItem?.customerid,
                };
                setEditReserveData(editData);
              }}
            >
              <span
                className="d-block material-symbols-outlined icon-md"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="update reserve data"
              >
                edit
              </span>
            </Link>
          ) : null}
          {/* --------- edit reserve with icon end ---------- */}
          {/* -------- dropdown section start -------- */}
          <div className="dropdown cell-dropdown">
          {/* ------ more vert icon start ------ */}
          <button
            className=" bg-transparent p-0 border-0"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span className="d-block material-symbols-outlined">more_vert</span>
          </button>
          {/* ------ more vert icon end ------ */}
          {/* ------ dropdown list start ------ */}
          {userInfo?.role?.name == "admin" ||
          userInfo?.role?.name == "manager" ? (
            <ul className="dropdown-menu border-0 shadow-lg">
              {/* ----- download material start ------ */}
              <li>
                <Link
                  className="dropdown-item"
                  to="#"
                  onClick={materialDownloadHandler}
                >
                  {t("Download Materials")}
                </Link>
              </li>
              {/* ----- download material end ------ */}
              {/* ----- Send Activity to beneficiary ------ */}
              <li>
                <Link
                  className="dropdown-item"
                  to="#"
                  onClick={() => {
                    mailToBeneficiary(dataItem);
                  }}
                >
                  {t("Send Activity to Responsible")}
                </Link>
              </li>
              {/* ----- Send Activity to observer ------ */}
              <li>
                <Link
                  className="dropdown-item"
                  to="#"
                  onClick={() => {
                    mailToObserver(dataItem);
                  }}
                >
                  {t("Send Activity to observer")}
                </Link>
              </li>
              {/* ----- view feedback start ------ */}
              <li>
                <Link
                  className="dropdown-item"
                  to="#allTotalReserveSurveyPopup"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="saveReservationPopup"
                  onClick={() => setCustomReserveId(dataItem.reserveid)}
                >
                  {t("View Feedback")}
                </Link>
              </li>
              {/* ----- view feedback end ------ */}
              {/* ----- Copy reserve start ------ */}
              <li>
                <Link
                  className="dropdown-item"
                  to="#saveReservationPopup"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="saveReservationPopup"
                  onClick={() => {
                    setCopyReserveData(dataItem.reserveid);
                  }}
                >
                  {t("Copy reserve")}
                </Link>
              </li>
              {/* ----- Copy reserve end ------ */}
              {/* ----- isconsecutive block start ------ */}
              {dataItem.isconsecutivereserve ? (
                <li>
                  <Link
                    className="dropdown-item"
                    to="#saveReservationPopup"
                    data-bs-toggle="offcanvas"
                    role="button"
                    aria-controls="saveReservationPopup"
                    onClick={() => {
                      setaddMoreConsecutiveReserveData(
                        dataItem.lastconsecutivereserve
                      );
                    }}
                  >
                    {t("Add more consecutive event")}
                  </Link>
                </li>
              ) : null}
              {/* ----- isconsecutive block end ------ */}
            </ul>
          ) : userInfo?.role?.name == "educator" ||
            userInfo?.role?.name == "beneficiary" ? (
            <ul className="dropdown-menu border-0 shadow-lg">
              {/* ----- download material start ------ */}
              <li>
                <Link
                  className="dropdown-item"
                  to="#"
                  onClick={materialDownloadHandler}
                >
                  {t("Download Materials")}
                </Link>
              </li>
              {/* ----- download material end ------ */}

              {/* view reserve modal */}
              <li>
                <Link
                  className="dropdown-item"
                  to="#reservationDetailsModal"
                  data-bs-toggle="modal"
                  onClick={() => {
                    setViewReserveData(dataItem);
                  }}
                >
                  {t("View Reserve")}
                </Link>
              </li>
            </ul>
          ) : (
            ""
          )}
          {/* ------ dropdown list end ------ */}
          </div>
          {/* -------- dropdown section end -------- */}
        </div>
        {/* -------- action icons + dropdown grouped end -------- */}
      </div>
    );
  };

  // Educator 1 Block
  const educatorOneblockHTML = ({ dataItem }) => {
    //function for change eductor set data in context
    const changeEducatorHandler = () => {
      let reserveData = {};
      if (dataItem.educators.length > 0) {
        reserveData = {
          startdate: dataItem.startdate,
          starttime: dataItem.starttime,
          endtime: dataItem.endtime,
          shift: dataItem.shift,
          reserveId: dataItem._id,
          prevEducatore: dataItem.educators[0]._id,
          activitycodename: dataItem.activitycode
            ? dataItem.activitycode.code +
              " : " +
              dataItem.activitycode.name
            : " ",
          reserveid: dataItem.reserveid,
          activitycode: dataItem.activity.value,
        };
      } else {
        reserveData = {
          startdate: dataItem.startdate,
          starttime: dataItem.starttime,
          endtime: dataItem.endtime,
          shift: dataItem.shift,
          reserveId: dataItem._id,
          prevEducatore: null,
          activitycodename: dataItem.activitycode
            ? dataItem.activitycode.code +
              " : " +
              dataItem.activitycode.name
            : " ",
          reserveid: dataItem.reserveid,
          activitycode: dataItem.activity.value,
        };
      }
      setChangeReserveEducatorData(reserveData);
    };
    //function for set person survey data in context
    const surveyHandler = () => {
      if (dataItem.educators.length > 0) {
        const reserveEvent = dataItem._id;
        const surveyPerson = dataItem.educators[0];
        const reserveid = dataItem.reserveid;
        let reserveSurveyData = {
          reserveEvent,
          surveyPerson,
          reserveid,
        };
        setReservePersonData(reserveSurveyData);
      } else {
        setReservePersonData(null);
      }
    };
    //function for set survey data for feedback
    const clientFeedBackHandler = () => {
      if (dataItem.educators.length > 0) {
        const reserveEvent = dataItem._id;
        const surveyPerson = dataItem.educators[0];
        const reserveid = dataItem.reserveid;
        let reserveSurveyData = {
          reserveEvent,
          surveyPerson,
          reserveid,
        };
        setClientFeedbackEducatorData(reserveSurveyData);
      } else {
        setClientFeedbackEducatorData(null);
      }
    };
    //function for mail history
    const mailHistory = () => {
      if (dataItem.educators.length > 0) {
        const reserveEvent = dataItem._id;
        const reserveId = dataItem.reserveid;
        const mailpersonid = dataItem.educators[0]._id;
        const mailPersonEmail = dataItem.educators[0].email;
        let reserveMailData = {
          reserveEvent,
          reserveId,
          mailpersonid,
          mailPersonEmail,
        };
        setReservationEmailHistoryData(reserveMailData);
      } else {
        setReservationEmailHistoryData(null);
      }
    };
    // Check if the conditions are met
    const isAdminOrManagerOrEducator =
      userInfo?.role?.name === "admin" ||
      userInfo?.role?.name === "manager" ||
      userInfo._id === dataItem?.educator1?._id;
    // Common link props for educatorOneLink
    const commonLinkProps = {
      className: "text-dark",
    };
    // If the conditions are met, set the onClick function and the to attribute
    const educatorOneLinkProps = isAdminOrManagerOrEducator
      ? {
          ...commonLinkProps,
          to: "#email_history_popup",
          "data-bs-toggle": "offcanvas",
          onClick: mailHistory,
        }
      : {
          ...commonLinkProps,
          to: "#",
        };
    return (
      <div className="educator1">
        {/* ----- educator name section start ------ */}
        <p className="name mb-1 d-inline-block">
          {dataItem?.educator1 ? (
            <Tooltip
              title={
                <div style={{ fontSize: "0.85rem", lineHeight: 1.6 }}>
                  {dataItem.educator1.email && (
                    <div>📧 {dataItem.educator1.email}</div>
                  )}
                  {dataItem.educator1.phone && (
                    <div>📞 {dataItem.educator1.phone}</div>
                  )}
                  {dataItem.educator1.location && (
                    <div>📍 {dataItem.educator1.location}</div>
                  )}
                  {dataItem.educator1.zipcode && (
                    <div>🏷️ {dataItem.educator1.zipcode}</div>
                  )}
                </div>
              }
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "white",
                    color: "text.primary",
                    border: "1px solid #dee2e6",
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 280,
                  },
                },
                arrow: { sx: { color: "white" } },
              }}
            >
              <Link
                {...educatorOneLinkProps}
                className="text-decoration-none"
              >
                {dataItem.educator1.name}
              </Link>
            </Tooltip>
          ) : (
            <Link {...educatorOneLinkProps} className="text-decoration-none">
              {dataItem?.educator1?.name}
            </Link>
          )}
        </p>
        {/* ----- educator name section end ------ */}
        {/* ----- educator icon section start ------ */}
        <div className="action d-flex gap-3 align-items-center">
          {dataItem.educator1 && (
            <p className="d-flex gap-1">
              {dataItem.educatoronemailtracker == "2" ? (
                <span className="d-block cursor-p material-symbols-outlined text-green icon-md">
                  mark_email_read
                </span>
              ) : (
                ""
              )}
              {dataItem.educatoronemailtracker == "1" ? (
                <span className="d-block cursor-p material-symbols-outlined text-grey icon-md">
                  mail
                </span>
              ) : (
                ""
              )}
              {dataItem.educatoronememberrsponsedate == "" ? null : (
                <span>{dataItem.educatoronememberrsponsedate}</span>
              )}
              <span
                className="d-block material-symbols-outlined icon-md icon-fill"
                style={{ color: dataItem.educatoronemailcolour }}
              >
                thumb_up
              </span>
            </p>
          )}
          <div className="d-flex gap-2 align-items-center">
            {/* ----- educator survey popup link start ------ */}
            {dataItem?.educator1 && (
              <div className="d-block">
                {isAdminOrManagerOrEducator ? (
                  <Link
                    to={
                      dataItem.educators.length > 0
                        ? "#allReserveSurveyPopup"
                        : "#"
                    }
                    role="button"
                    className="text-gray-700"
                    data-bs-toggle="offcanvas"
                    onClick={surveyHandler}
                  >
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="All survey"
                      className="d-block material-symbols-outlined icon-md"
                    >
                      forum
                    </span>
                  </Link>
                ) : null}
              </div>
            )}
            {/* ----- educator survey popup link end ------ */}
            {/* ----- educator replace popup link start ------ */}
            {userInfo?.role?.name == "admin" ||
            userInfo?.role?.name == "manager" ? (
              <div className="d-block">
                <Link
                  to="#selectEducatorPopup"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="saveReservationPopup"
                  className="text-black"
                  onClick={changeEducatorHandler}
                >
                  <span
                    className="d-block material-symbols-outlined icon-md"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Select educator"
                  >
                    {dataItem.educator1 ? "edit" : "add"}
                  </span>
                </Link>
              </div>
            ) : null}

            {/* ----- educator replace popup link end ------ */}
            {/* ----- client to educator survey popup link start ------ */}
            {userInfo?.role?.name == "client" ||
            userInfo.role?.name == "educator" ||
            userInfo?.role?.name === "admin" ? (
              <div className="d-block">
                {dataItem.educator1 && (
                  <Link
                    to="#client_educator_reserve_survey_feedback_popup"
                    data-bs-toggle="offcanvas"
                    role="button"
                    aria-controls="saveReservationPopup"
                    className="text-black"
                    onClick={clientFeedBackHandler}
                  >
                    <span
                      className="d-block material-symbols-outlined icon-md"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Select educator"
                    >
                      try
                    </span>
                  </Link>
                )}
              </div>
            ) : null}
            {/* ----- client to educator survey popup link end ------ */}
            {/* update educator details  */}
            {userInfo?.role?.name == "admin" ||
            userInfo?.role?.name == "manager" ? (
              <div className="d-block">
                {dataItem.educator1 && (
                  <Link
                    to="#saveClientPopup"
                    data-bs-toggle="offcanvas"
                    role="button"
                    aria-controls="saveReservationPopup"
                    className="text-black"
                    onClick={() => {
                      handelClientSelect(dataItem.educator1._id);
                    }}
                  >
                    <span
                      className="d-block material-symbols-outlined icon-md"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Update educator"
                    >
                      arrow_forward
                    </span>
                  </Link>
                )}
              </div>
            ) : null}
          </div>
        </div>
        {/* ----- educator icon section end ------ */}
      </div>
    );
  };

  // Educator 2 Block
  const educatorTwoblockHTML = ({ dataItem }) => {
    //function for change eductor set data in context
    const changeEducatorHandler = () => {
      let reserveData = {};
      if (dataItem.educators.length > 1) {
        reserveData = {
          startdate: dataItem.startdate,
          starttime: dataItem.starttime,
          endtime: dataItem.endtime,
          reserveId: dataItem._id,
          prevEducatore: dataItem.educators[1]._id,
          activitycodename: dataItem.activitycode
            ? dataItem.activitycode.code +
              " : " +
              dataItem.activitycode.name
            : " ",
          reserveid: dataItem.reserveid,
          activitycode: dataItem.activity.value,
        };
      } else {
        reserveData = {
          startdate: dataItem.startdate,
          starttime: dataItem.starttime,
          endtime: dataItem.endtime,
          reserveId: dataItem._id,
          prevEducatore: null,
          activitycodename: dataItem.activitycode
            ? dataItem.activitycode.code +
              " : " +
              dataItem.activitycode.name
            : " ",
          reserveid: dataItem.reserveid,
          activitycode: dataItem.activity.value,
        };
      }
      setChangeReserveEducatorData(reserveData);
    };
    //function for set person survey data in context
    const surveyHandler = () => {
      if (dataItem.educators.length > 1) {
        const reserveEvent = dataItem._id;
        const surveyPerson = dataItem.educators[1];
        const reserveid = dataItem.reserveid;
        let reserveSurveyData = {
          reserveEvent,
          surveyPerson,
          reserveid,
        };
        setReservePersonData(reserveSurveyData);
      } else {
        setReservePersonData(null);
      }
    };
    //function for set survey data for feedback
    const clientFeedBackHandler = () => {
      if (dataItem.educators.length > 0) {
        const reserveEvent = dataItem._id;
        const surveyPerson = dataItem.educators[1];
        const reserveid = dataItem.reserveid;
        let reserveSurveyData = {
          reserveEvent,
          surveyPerson,
          reserveid,
        };
        setClientFeedbackEducatorData(reserveSurveyData);
      } else {
        setClientFeedbackEducatorData(null);
      }
    };
    //function for mail history
    const mailHistory = () => {
      if (dataItem.educators.length > 1) {
        const reserveEvent = dataItem._id;
        const reserveId = dataItem.reserveid;
        const mailpersonid = dataItem.educators[1]._id;
        const mailPersonEmail = dataItem.educators[1].email;
        let reserveMailData = {
          reserveEvent,
          reserveId,
          mailpersonid,
          mailPersonEmail,
        };
        setReservationEmailHistoryData(reserveMailData);
      } else {
        setReservationEmailHistoryData(null);
      }
    };
    // Check if the conditions are met
    const isAdminOrManagerOrEducator =
      userInfo?.role?.name === "admin" ||
      userInfo?.role?.name === "manager" ||
      userInfo._id === dataItem?.educator2?._id;
    // Common link props for educatorOneLink
    const commonLinkProps = {
      className: "text-dark",
    };
    // If the conditions are met, set the onClick function and the to attribute
    const educatorTwoLinkProps = isAdminOrManagerOrEducator
      ? {
          ...commonLinkProps,
          to: "#email_history_popup",
          "data-bs-toggle": "offcanvas",
          onClick: mailHistory,
        }
      : {
          ...commonLinkProps,
          to: "#",
        };
    return (
      <div className="educator2">
        <p className="name mb-1 d-inline-block">
          {dataItem?.educator2 ? (
            <Tooltip
              title={
                <div style={{ fontSize: "0.85rem", lineHeight: 1.6 }}>
                  {dataItem.educator2.email && (
                    <div>📧 {dataItem.educator2.email}</div>
                  )}
                  {dataItem.educator2.phone && (
                    <div>📞 {dataItem.educator2.phone}</div>
                  )}
                  {dataItem.educator2.location && (
                    <div>📍 {dataItem.educator2.location}</div>
                  )}
                  {dataItem.educator2.zipcode && (
                    <div>🏷️ {dataItem.educator2.zipcode}</div>
                  )}
                </div>
              }
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "white",
                    color: "text.primary",
                    border: "1px solid #dee2e6",
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 280,
                  },
                },
                arrow: { sx: { color: "white" } },
              }}
            >
              <Link
                {...educatorTwoLinkProps}
                className="text-decoration-none"
              >
                {dataItem.educator2.name}
              </Link>
            </Tooltip>
          ) : (
            <Link {...educatorTwoLinkProps} className="text-decoration-none">
              {dataItem?.educator2?.name}
            </Link>
          )}
        </p>
        {/* ----- educator icon section start ------ */}
        <div className="action d-flex gap-3 align-items-center">
          {dataItem.educator2 && (
            <p className="d-flex gap-1">
              {dataItem.educatortwomailtracker == "2" ? (
                <span className="d-block cursor-p material-symbols-outlined text-green icon-md">
                  mark_email_read
                </span>
              ) : (
                ""
              )}
              {dataItem.educatortwomailtracker == "1" ? (
                <span className="d-block cursor-p material-symbols-outlined text-grey icon-md">
                  mail
                </span>
              ) : (
                ""
              )}
              {dataItem.educatortwomemberrsponsedate == "" ? null : (
                <span>{dataItem.educatortwomemberrsponsedate}</span>
              )}
              <span
                className="d-block material-symbols-outlined icon-md icon-fill"
                style={{ color: dataItem.educatortwomailcolour }}
              >
                thumb_up
              </span>
            </p>
          )}
          <div className="action d-flex gap-2 align-items-center">
            {/* ----- educator survey popup link start ------ */}
            {dataItem.educator2 ? (
              <div className="d-block">
                {isAdminOrManagerOrEducator ? (
                  <Link
                    onClick={surveyHandler}
                    data-bs-toggle="offcanvas"
                    to={
                      dataItem.educators.length > 1
                        ? "#allReserveSurveyPopup"
                        : "#"
                    }
                    role="button"
                    className="text-green"
                  >
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="All survey"
                      className="d-block material-symbols-outlined icon-md"
                    >
                      forum
                    </span>
                  </Link>
                ) : null}
              </div>
            ) : null}
            {/* ----- educator replace popup link start ------ */}
            {userInfo?.role?.name == "admin" ||
            userInfo?.role?.name == "manager" ? (
              <div className="d-block">
                <Link
                  to="#selectEducatorPopup"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="saveReservationPopup"
                  className="text-black"
                  onClick={changeEducatorHandler}
                >
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Select educator"
                    className="d-block material-symbols-outlined icon-md"
                  >
                    {dataItem.educator2 ? "edit" : "add"}
                  </span>
                </Link>
              </div>
            ) : null}
            {/* ----- client to educator survey popup link start ------ */}
            {userInfo?.role?.name == "client" ||
            userInfo.role?.name == "educator" ||
            userInfo?.role?.name === "admin" ? (
              <div className="d-block">
                {dataItem.educator2 && (
                  <Link
                    to="#client_educator_reserve_survey_feedback_popup"
                    data-bs-toggle="offcanvas"
                    role="button"
                    aria-controls="saveReservationPopup"
                    className="text-black"
                    onClick={clientFeedBackHandler}
                  >
                    <span
                      className="d-block material-symbols-outlined icon-md"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Select educator"
                    >
                      try
                    </span>
                  </Link>
                )}
              </div>
            ) : null}
            {/* ----- client to educator survey popup link end ------ */}
            {/* update educator details  */}
            {userInfo?.role?.name == "admin" ||
            userInfo?.role?.name == "manager" ? (
              <div className="d-block">
                {dataItem.educator2 && (
                  <Link
                    to="#saveClientPopup"
                    data-bs-toggle="offcanvas"
                    role="button"
                    aria-controls="saveReservationPopup"
                    className="text-black"
                    onClick={() => {
                      handelClientSelect(dataItem.educator2._id);
                    }}
                  >
                    <span
                      className="d-block material-symbols-outlined icon-md"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Update educator"
                    >
                      arrow_forward
                    </span>
                  </Link>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  // Client Block
  const clientBlockHTML = ({ dataItem }) => {
    //function for set person survey data in context
    const surveyHandler = () => {
      if (dataItem.clients.length > 0) {
        const reserveEvent = dataItem._id;
        const surveyPerson = dataItem.clients[0];
        const reserveid = dataItem.reserveid;
        let reserveSurveyData = {
          reserveEvent,
          surveyPerson,
          reserveid,
        };
        setReservePersonData(reserveSurveyData);
      } else {
        setReservePersonData(null);
      }
    };

    //function for mail history
    const mailHistory = () => {
      if (dataItem.clients.length > 0) {
        const reserveEvent = dataItem._id;
        const reserveId = dataItem.reserveid;
        const mailpersonid = dataItem.clients[0]._id;
        const mailPersonEmail = dataItem.clients[0].email;
        const mailPersonPhone = dataItem.clients[0].phone;
        const mailPersonLocation = dataItem.clients[0].location;
        const mailPersonZipcode = dataItem.clients[0].zipcode;
        let reserveMailData = {
          reserveEvent,
          reserveId,
          mailpersonid,
          mailPersonEmail,
          mailPersonPhone,
          mailPersonLocation,
          mailPersonZipcode,
        };
        setReservationEmailHistoryData(reserveMailData);
      } else {
        setReservationEmailHistoryData(null);
      }
    };

    // Check if the conditions are met
    const isAdminOrManagerOrClient =
      userInfo?.role?.name === "admin" ||
      userInfo?.role?.name === "manager" ||
      userInfo._id === dataItem?.client?._id;
    // Common link props for clientLink
    const commonLinkProps = {
      className: "text-dark",
    };
    // Add additional link props if the conditions are met
    const clientLinkProps = isAdminOrManagerOrClient
      ? {
          ...commonLinkProps,
          to: "#email_history_popup",
          "data-bs-toggle": "offcanvas",
          onClick: mailHistory,
        }
      : {
          ...commonLinkProps,
          to: "#",
        };
    return (
      <div className="clients">
        <p className="name mb-1 d-inline-block">
          {dataItem?.client ? (
            <Tooltip
              title={
                <div style={{ fontSize: "0.85rem", lineHeight: 1.6 }}>
                  {dataItem.client.email && (
                    <div>📧 {dataItem.client.email}</div>
                  )}
                  {dataItem.client.phone && (
                    <div>📞 {dataItem.client.phone}</div>
                  )}
                  {dataItem.client.location && (
                    <div>📍 {dataItem.client.location}</div>
                  )}
                  {dataItem.client.zipcode && (
                    <div>🏷️ {dataItem.client.zipcode}</div>
                  )}
                </div>
              }
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "white",
                    color: "text.primary",
                    border: "1px solid #dee2e6",
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 280,
                  },
                },
                arrow: { sx: { color: "white" } },
              }}
            >
              <Link
                {...clientLinkProps}
                className="text-decoration-none"
              >
                {dataItem.client.name}
              </Link>
            </Tooltip>
          ) : (
            <Link {...clientLinkProps} className="text-decoration-none">
              {dataItem?.client?.name}
            </Link>
          )}
        </p>
        <div className="action d-flex gap-2 align-items-center">
          {dataItem.client && (
            <div className="d-block">
              {isAdminOrManagerOrClient ? (
                <Link
                  onClick={surveyHandler}
                  to="#allReserveSurveyPopup"
                  data-bs-toggle="offcanvas"
                  className="text-gray-700"
                >
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="All Survey"
                    className="d-block material-symbols-outlined icon-md"
                  >
                    forum
                  </span>
                </Link>
              ) : null}
            </div>
          )}

          {dataItem.client && (
            <div className="d-block">
              {isAdminOrManagerOrClient ? (
                <Link
                  to="#saveClientPopup"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="saveReservationPopup"
                  className="text-black"
                  onClick={() => {
                    handelClientSelect(dataItem.client._id);
                  }}
                >
                  <span
                    className="d-block material-symbols-outlined icon-md"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Update Client"
                  >
                    arrow_forward
                  </span>
                </Link>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  };

  // Observer Block
  const observerHTML = ({ dataItem }) => {
    //function for set person survey data in context
    const surveyHandler = () => {
      if (dataItem.observers.length > 0) {
        const reserveEvent = dataItem._id;
        const surveyPerson = dataItem.observers[0];
        const reserveid = dataItem.reserveid;
        let reserveSurveyData = {
          reserveEvent,
          surveyPerson,
          reserveid,
        };
        setReservePersonData(reserveSurveyData);
      } else {
        setReservePersonData(null);
      }
    };
    //function for mail history
    const mailHistory = () => {
      if (dataItem.observers.length > 0) {
        const reserveEvent = dataItem._id;
        const reserveId = dataItem.reserveid;
        const mailpersonid = dataItem.observers[0]._id;
        const mailPersonEmail = dataItem.observers[0].email;
        let reserveMailData = {
          reserveEvent,
          reserveId,
          mailpersonid,
          mailPersonEmail,
        };
        setReservationEmailHistoryData(reserveMailData);
      } else {
        setReservationEmailHistoryData(null);
      }
    };
    // Check if the conditions are met
    const isAdminOrManagerOrObserver =
      userInfo?.role?.name === "admin" ||
      userInfo?.role?.name === "manager" ||
      userInfo._id === dataItem?.observer?._id;
    // Common link props for observer
    const commonLinkProps = {
      className: "text-dark",
    };
    // Add additional link props if the conditions are met
    const observerLinkProps = isAdminOrManagerOrObserver
      ? {
          ...commonLinkProps,
          to: "#email_history_popup",
          "data-bs-toggle": "offcanvas",
          onClick: mailHistory,
        }
      : {
          ...commonLinkProps,
          to: "#",
        };
    return (
      <div className="observer">
        <p className="name mb-1 d-inline-block">
          {dataItem?.observer ? (
            <Tooltip
              title={
                <div style={{ fontSize: "0.85rem", lineHeight: 1.6 }}>
                  {dataItem.observer.email && (
                    <div>📧 {dataItem.observer.email}</div>
                  )}
                  {dataItem.observer.phone && (
                    <div>📞 {dataItem.observer.phone}</div>
                  )}
                  {dataItem.observer.location && (
                    <div>📍 {dataItem.observer.location}</div>
                  )}
                  {dataItem.observer.zipcode && (
                    <div>🏷️ {dataItem.observer.zipcode}</div>
                  )}
                </div>
              }
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "white",
                    color: "text.primary",
                    border: "1px solid #dee2e6",
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 280,
                  },
                },
                arrow: { sx: { color: "white" } },
              }}
            >
              <Link
                {...observerLinkProps}
                className="text-decoration-none"
              >
                {dataItem.observer.name}
              </Link>
            </Tooltip>
          ) : (
            <Link {...observerLinkProps} className="text-decoration-none">
              {dataItem?.observer?.name}
            </Link>
          )}
        </p>

        <div className="action d-flex gap-2 align-items-center">
          {dataItem.observer && (
            <div className="d-block">
              {isAdminOrManagerOrObserver ? (
                <Link
                  onClick={surveyHandler}
                  to="#allReserveSurveyPopup"
                  data-bs-toggle="offcanvas"
                  className="text-gray-700"
                >
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="All Survey"
                    className="d-block material-symbols-outlined icon-md"
                  >
                    forum
                  </span>
                </Link>
              ) : null}
            </div>
          )}

          {dataItem.observer && (
            <div className="d-block">
              {isAdminOrManagerOrObserver ? (
                <Link
                  to="#saveClientPopup"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="saveReservationPopup"
                  className="text-black"
                  onClick={() => {
                    handelClientSelect(dataItem.observer._id);
                  }}
                >
                  <span
                    className="d-block material-symbols-outlined icon-md"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Update Observer"
                  >
                    arrow_forward
                  </span>
                </Link>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  };

  // Benificiary Block
  const benificiaryHTML = ({ dataItem }) => {
    //function for set person survey data in context
    const surveyHandler = () => {
      if (dataItem.beneficiaries.length > 0) {
        const reserveEvent = dataItem._id;
        const surveyPerson = dataItem.beneficiaries[0];
        const reserveid = dataItem.reserveid;
        let reserveSurveyData = {
          reserveEvent,
          surveyPerson,
          reserveid,
        };
        setReservePersonData(reserveSurveyData);
      } else {
        setReservePersonData(null);
      }
    };
    //function for mail history
    const mailHistory = () => {
      if (dataItem.beneficiaries.length > 0) {
        const reserveEvent = dataItem._id;
        const reserveId = dataItem.reserveid;
        const mailpersonid = dataItem.beneficiaries[0]._id;
        const mailPersonEmail = dataItem.beneficiaries[0].email;
        const mailPersonPhone = dataItem.beneficiaries[0].phone;
        let reserveMailData = {
          reserveEvent,
          reserveId,
          mailpersonid,
          mailPersonEmail,
          mailPersonPhone,
        };
        setReservationEmailHistoryData(reserveMailData);
      } else {
        setReservationEmailHistoryData(null);
      }
    };
    // Check if the conditions are met
    const isAdminOrManagerOrBenificiary =
      userInfo?.role?.name === "admin" ||
      userInfo?.role?.name === "manager" ||
      userInfo._id === dataItem?.beneficiary?._id;
    // Common link props for observer
    const commonLinkProps = {
      className: "text-dark",
    };
    // Add additional link props if the conditions are met
    const benificiaryLinkProps = isAdminOrManagerOrBenificiary
      ? {
          ...commonLinkProps,
          to: "#email_history_popup",
          "data-bs-toggle": "offcanvas",
          onClick: mailHistory,
        }
      : {
          ...commonLinkProps,
          to: "#",
        };
    return (
      <div className="beneficiary">
        <p className="name mb-1 d-inline-block">
          {dataItem?.beneficiary ? (
            <Tooltip
              title={
                <div style={{ fontSize: "0.85rem", lineHeight: 1.6 }}>
                  {dataItem.beneficiary.email && (
                    <div>📧 {dataItem.beneficiary.email}</div>
                  )}
                  {dataItem.beneficiary.phone && (
                    <div>📞 {dataItem.beneficiary.phone}</div>
                  )}
                  {dataItem.beneficiary.location && (
                    <div>📍 {dataItem.beneficiary.location}</div>
                  )}
                  {dataItem.beneficiary.zipcode && (
                    <div>🏷️ {dataItem.beneficiary.zipcode}</div>
                  )}
                </div>
              }
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "white",
                    color: "text.primary",
                    border: "1px solid #dee2e6",
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 280,
                  },
                },
                arrow: { sx: { color: "white" } },
              }}
            >
              <Link
                {...benificiaryLinkProps}
                className="text-decoration-none"
              >
                {dataItem.beneficiary.name}
              </Link>
            </Tooltip>
          ) : (
            <Link {...benificiaryLinkProps} className="text-decoration-none">
              {dataItem?.beneficiary?.name}
            </Link>
          )}
        </p>
        {/* ----- educator icon section start ------ */}
        <div className="action d-flex gap-3 align-items-center">
          {dataItem.beneficiary && (
            <p className="d-flex gap-1">
              {dataItem.beneficiarymailtracker == "2" ? (
                <span className="d-block cursor-p material-symbols-outlined text-green icon-md">
                  mark_email_read
                </span>
              ) : (
                ""
              )}
              {dataItem.beneficiarymailtracker == "1" ? (
                <span className="d-block cursor-p material-symbols-outlined text-grey icon-md">
                  mail
                </span>
              ) : (
                ""
              )}
              {dataItem.beneficiarymemberresponsedate == "" ? null : (
                <span>{dataItem.beneficiarymemberresponsedate}</span>
              )}
              <span
                className="d-block material-symbols-outlined icon-md icon-fill"
                style={{ color: dataItem.beneficiarymailcolour }}
              >
                thumb_up
              </span>
            </p>
          )}
          <div className="d-flex gap-2 align-items-center">
            {/* ----- educator survey popup link start ------ */}
            {dataItem.beneficiary && (
              <div className="d-block">
                {isAdminOrManagerOrBenificiary ? (
                  <Link
                    onClick={surveyHandler}
                    to="#allReserveSurveyPopup"
                    data-bs-toggle="offcanvas"
                    className="text-gray-700"
                  >
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="All Survey"
                      className="d-block material-symbols-outlined icon-md"
                    >
                      forum
                    </span>
                  </Link>
                ) : null}
              </div>
            )}
          </div>

          {dataItem.beneficiary && (
            <div className="d-block">
              {isAdminOrManagerOrBenificiary ? (
                <Link
                  to="#saveClientPopup"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="saveReservationPopup"
                  className="text-black"
                  onClick={() => {
                    handelClientSelect(dataItem.beneficiary._id);
                  }}
                >
                  <span
                    className="d-block material-symbols-outlined icon-md"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Update Beneficiary"
                  >
                    arrow_forward
                  </span>
                </Link>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  };

  //responsible Block
  const responsibleHTML = ({ dataItem }) => {
    //function for set person survey data in context
    const surveyHandler = () => {
      if (
        dataItem?.responsibles &&
        dataItem?.responsibles?.length > 0
      ) {
        const reserveEvent = dataItem._id;
        const surveyPerson = dataItem?.responsibles[0];
        const reserveid = dataItem?.reserveid;
        let reserveSurveyData = {
          reserveEvent,
          surveyPerson,
          reserveid,
        };
        setReservePersonData(reserveSurveyData);
      } else {
        setReservePersonData(null);
      }
    };
    //function for mail history
    const mailHistory = () => {
      if (
        dataItem.responsibles &&
        dataItem.responsibles.length > 0
      ) {
        const reserveEvent = dataItem._id;
        const reserveId = dataItem?.reserveid;
        const mailpersonid = dataItem?.responsibles[0]._id;
        const mailPersonEmail = dataItem?.responsibles[0].email;
        let reserveMailData = {
          reserveEvent,
          reserveId,
          mailpersonid,
          mailPersonEmail,
        };
        setReservationEmailHistoryData(reserveMailData);
      } else {
        setReservationEmailHistoryData(null);
      }
    };
    // Check if the conditions are met
    const isAdminOrManagerOrResponsible =
      userInfo?.role?.name === "admin" ||
      userInfo?.role?.name === "manager" ||
      userInfo._id === dataItem?.responsible?._id;
    // Common link props for observer
    const commonLinkProps = {
      className: "text-dark",
    };
    // Add additional link props if the conditions are met
    const responsibleLinkProps = isAdminOrManagerOrResponsible
      ? {
          ...commonLinkProps,
          to: "#email_history_popup",
          "data-bs-toggle": "offcanvas",
          onClick: mailHistory,
        }
      : {
          ...commonLinkProps,
          to: "#",
        };
    return (
      <div className="responsible">
        <p className="name mb-1 d-inline-block">
          {dataItem?.responsible ? (
            <Tooltip
              title={
                <div style={{ fontSize: "0.85rem", lineHeight: 1.6 }}>
                  {dataItem.responsible.email && (
                    <div>📧 {dataItem.responsible.email}</div>
                  )}
                  {dataItem.responsible.phone && (
                    <div>📞 {dataItem.responsible.phone}</div>
                  )}
                  {dataItem.responsible.location && (
                    <div>📍 {dataItem.responsible.location}</div>
                  )}
                  {dataItem.responsible.zipcode && (
                    <div>🏷️ {dataItem.responsible.zipcode}</div>
                  )}
                </div>
              }
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "white",
                    color: "text.primary",
                    border: "1px solid #dee2e6",
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 280,
                  },
                },
                arrow: { sx: { color: "white" } },
              }}
            >
              <Link
                {...responsibleLinkProps}
                className="text-decoration-none"
              >
                {dataItem.responsible.name}
              </Link>
            </Tooltip>
          ) : (
            <Link {...responsibleLinkProps} className="text-decoration-none">
              {dataItem.responsible?.name}
            </Link>
          )}
        </p>
        {/* ----- educator icon section start ------ */}
        <div className="action d-flex gap-3 align-items-center">
          {dataItem?.responsible && (
            <p className="d-flex gap-1">
              {dataItem.responsiblemailtracker == "2" ? (
                <span className="d-block cursor-p material-symbols-outlined text-green icon-md">
                  mark_email_read
                </span>
              ) : (
                ""
              )}
              {dataItem.responsiblemailtracker == "1" ? (
                <span className="d-block cursor-p material-symbols-outlined text-grey icon-md">
                  mail
                </span>
              ) : (
                ""
              )}
              {dataItem.responsiblememberresponsedate == "" ? null : (
                <span>{dataItem.responsiblememberresponsedate}</span>
              )}
              <span
                className="d-block material-symbols-outlined icon-md icon-fill"
                style={{ color: dataItem.responsiblemailcolour }}
              >
                thumb_up
              </span>
            </p>
          )}
          <div className="action d-flex gap-2 align-items-center">
            {/* ----- educator survey popup link start ------ */}
            {dataItem.responsible && (
              <div className="d-block">
                {isAdminOrManagerOrResponsible ? (
                  <Link
                    onClick={surveyHandler}
                    to="#allReserveSurveyPopup"
                    data-bs-toggle="offcanvas"
                    className="text-gray-700"
                  >
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="All Survey"
                      className="d-block material-symbols-outlined icon-md"
                    >
                      forum
                    </span>
                  </Link>
                ) : null}
              </div>
            )}
          </div>

          {dataItem.responsible && (
            <div className="d-block">
              {isAdminOrManagerOrResponsible ? (
                <Link
                  to="#saveClientPopup"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="saveReservationPopup"
                  className="text-black"
                  onClick={() => {
                    handelClientSelect(dataItem.responsible._id);
                  }}
                >
                  <span
                    className="d-block material-symbols-outlined icon-md"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Update Responsible"
                  >
                    arrow_forward
                  </span>
                </Link>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  };

  // Location Block
  const locationHTML = ({ dataItem }) => {
    return (
      <p className="d-flex gap-2 align-items-center text-nowrap">
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={dataItem?.location ?? ""}
          className="d-block material-symbols-outlined icon-md text-black"
        >
          location_on
        </span>
        <span className="d-block">{dataItem?.location ?? ""}</span>
      </p>
    );
  };

  // Status Block
  const statusHTML = ({ dataItem }) => {
    return (
      <p className="d-flex gap-2 align-items-center">
        <span className="d-block">
          {t(dataItem?.reservestatus ?? "")}
        </span>
        <span
          className={`d-block material-symbols-outlined icon-md ${
            dataItem?.reservestatus === "Confirmed"
              ? "text-green"
              : "text-danger"
          }`}
        >
          {dataItem?.reservestatus === "Confirmed"
            ? "check_circle"
            : dataItem?.reservestatus === "Pending Confirmation"
            ? "pending"
            : "clear"}
        </span>
      </p>
    );
  };

  /* custom comments html */
  const commentHtml = ({ dataItem }) => {
    return (
      <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={dataItem?.comments ?? ""}
      >
        {dataItem && dataItem.comments
          ? dataItem?.comments.length > 20
            ? dataItem?.comments.slice(0, 20) + "..."
            : dataItem.comments
          : ""}
      </span>
    );
  };

  //custom internal comments html
  const insternalCommentsHtml = ({ dataItem }) => {
    return (
      <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={dataItem?.internalcomment ?? ""}
      >
        {dataItem && dataItem.internalcomment
          ? dataItem?.internalcomment?.length > 20
            ? dataItem?.internalcomment.slice(0, 20) + "..."
            : dataItem?.internalcomment
          : ""}
      </span>
    );
  };

  //salesorder html
  const salesOrderHtml = ({ dataItem }) => {
    return (
      <>
        {dataItem?.salesorderids && (
          <p>
            {dataItem?.salesorderids.map((item, index) => {
              return (
                <span key={index}>
                  {item?.invoiceid}
                  <br />
                </span>
              );
            })}
          </p>
        )}
      </>
    );
  };

  //custom reconfirm html
  const reConfirmHtml = ({ dataItem }) => {
    return (
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          value={dataItem._id}
          defaultChecked={dataItem?.reconfirmation}
          name="selectReserveReconfirmation"
          onClick={(e) => {
            reConfirmHandler(e);
          }}
        />
      </div>
    );
  };

  //date html
  const reserveDateBlockHTML = ({ dataItem }) => {
    return <p>{dataItem.reservedate}</p>;
  };

  //function for reset other component states
  const resetOtherComponentStates = () => {
    setSearchReserveDate("");
    setSearchReserveIdList([]);
    setSearchReserveActivity([]);
    setSearchReserveLabels([]);
    setSearchReserveBenificiaries([]);
    setSearchReserveClients([]);
    setSearchReserveEducators([]);
    setSearchReserveStatus([]);
    setisConsecutiveReserveFilter(false);
    setUnsentMailReserveFilter(false);
  };

  // Update selected count when row selection changes
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter(key => rowSelection[key]).length;
    const selectedData = getSelectedData();
    checkedRecordCount(selectedCount, selectedData);
  }, [rowSelection, reservationList]);

  // Column definitions for MaterialReactTable
  const tableColumns = useMemo(() => {
    // Memoized cell wrappers — created once per tableColumns computation (i.e. only
    // when the visible column set changes). React.memo bails out of re-rendering a
    // cell whenever row.original is the same object reference, which is the case for
    // all re-renders that aren't triggered by a data fetch (e.g. row selection
    // changes, context updates from edit popups, notifications, etc.).

    const allColumnDefs = [
      {
        id: "customerid",
        accessorKey: "customerid",
        header: t("Customer ID"),
        Cell: ({ row }) => primaryBlockHtml({ dataItem: row.original }),
        size: 200,
        _colName: null, // always visible
        muiTableBodyCellProps: {
          sx: { overflow: "visible", position: "static" },
        },
      },
      {
        id: "shiftlabel",
        accessorKey: "shiftlabel",
        header: t("Shift"),
        size: 100,
        _colName: "Shift",
      },
      {
        id: "startdate",
        accessorKey: "startdate",
        header: t("Date"),
        Cell: ({ row }) => reserveDateBlockHTML({ dataItem: row.original }),
        size: 200,
        _colName: "Date",
      },
      {
        id: "reserveday",
        accessorKey: "reserveday",
        header: t("Day"),
        size: 200,
        _colName: "Day",
      },
      {
        id: "starttime",
        accessorKey: "starttime",
        header: t("Start Time"),
        size: 200,
        _colName: "Start Time",
      },
      {
        id: "endtime",
        accessorKey: "endtime",
        header: t("End Time"),
        size: 200,
        _colName: "End Time",
      },
      {
        id: "activitycode_code",
        accessorFn: (row) => row.activitycode?.code ?? "",
        header: t("Code"),
        size: 200,
        _colName: "Code",
      },
      {
        id: "activitycode_name",
        accessorFn: (row) => row.activitycode?.name ?? "",
        header: t("Activity"),
        size: 300,
        _colName: "Activity",
      },
      {
        id: "activitytype",
        accessorKey: "activitytype",
        header: t("Activity Type"),
        size: 200,
        _colName: "Activity Type",
      },
      {
        id: "tagstring",
        accessorKey: "tagstring",
        header: t("Tags"),
        size: 200,
        _colName: "Tags",
      },
      {
        id: "educator1",
        accessorFn: (row) => row.educator1?.name ?? "",
        header: t("Educator 1"),
        Cell: ({ row }) => educatorOneblockHTML({ dataItem: row.original }),
        size: 250,
        _colName: "Educator 1",
      },
      {
        id: "educator2",
        accessorFn: (row) => row.educator2?.name ?? "",
        header: t("Educator 2"),
        Cell: ({ row }) => educatorTwoblockHTML({ dataItem: row.original }),
        size: 250,
        _colName: "Educator 2",
      },
      {
        id: "client",
        accessorFn: (row) => row.client?.name ?? "",
        header: t("Client"),
        Cell: ({ row }) => clientBlockHTML({ dataItem: row.original }),
        size: 200,
        _colName: "Client",
      },
      {
        id: "observer",
        accessorFn: (row) => row.observer?.name ?? "",
        header: t("Observer"),
        Cell: ({ row }) => observerHTML({ dataItem: row.original }),
        size: 200,
        _colName: "Observer",
      },
      {
        id: "beneficiary",
        accessorFn: (row) => row.beneficiary?.name ?? "",
        header: t("Beneficiary"),
        Cell: ({ row }) => benificiaryHTML({ dataItem: row.original }),
        size: 200,
        _colName: "Beneficiary",
      },
      {
        id: "responsible",
        accessorFn: (row) => row.responsible?.name ?? "",
        header: t("Responsible"),
        Cell: ({ row }) => responsibleHTML({ dataItem: row.original }),
        size: 200,
        _colName: "Responsible",
      },
      {
        id: "participantcount",
        accessorKey: "participantcount",
        header: t("No of Participants"),
        size: 200,
        _colName: "No of Participants",
      },
      {
        id: "educatorcount",
        accessorKey: "educatorcount",
        header: t("No of Educator"),
        //size: 200,
        _colName: "No of Educator",
      },
      {
        id: "realparticipantcount",
        accessorKey: "realparticipantcount",
        header: t("No Participants Real"),
        size: 300,
        _colName: "No Participants Real",
      },
      {
        id: "tutor",
        accessorKey: "tutor",
        header: t("Tutor"),
        //size: 100,
        _colName: "Tutor",
      },
      {
        id: "specificaudiencestring",
        accessorKey: "specificaudiencestring",
        header: t("Specific Audience"),
        //size: 180,
        _colName: "Specific Audience",
      },
      {
        id: "grade",
        accessorKey: "grade",
        header: t("Grade"),
        //size: 180,
        _colName: "Grade",
      },
      {
        id: "salesorderstring",
        accessorKey: "salesorderstring",
        header: t("Sales order"),
        Cell: ({ row }) => salesOrderHtml({ dataItem: row.original }),
        size: 180,
        _colName: "Sales Order",
      },
      {
        id: "comments",
        accessorKey: "comments",
        header: t("Comments"),
        Cell: ({ row }) => commentHtml({ dataItem: row.original }),
        size: 200,
        _colName: "Comments",
      },
      {
        id: "internalcomment",
        accessorKey: "internalcomment",
        header: t("Int. Comments"),
        Cell: ({ row }) => insternalCommentsHtml({ dataItem: row.original }),
        size: 200,
        _colName: "InternalComments",
      },
      {
        id: "location",
        accessorKey: "location",
        header: t("Location"),
        Cell: ({ row }) => locationHTML({ dataItem: row.original }),
        size: 200,
        _colName: "Location",
      },
      {
        id: "zipcode",
        accessorKey: "zipcode",
        header: t("Zipcode"),
        size: 200,
        _colName: "Zipcode",
      },
      {
        id: "reservestatus",
        accessorKey: "reservestatus",
        header: t("Status"),
        Cell: ({ row }) => statusHTML({ dataItem: row.original }),
        size: 200,
        _colName: "Status",
      },
    ];

    // Add reconfirmation column for admin/manager
    if (
      userInfo?.role?.name === "admin" ||
      userInfo?.role?.name === "manager"
    ) {
      allColumnDefs.push({
        id: "reconfirmation",
        accessorKey: "reconfirmation",
        header: t("Reconfirmation"),
        Cell: ({ row }) => reConfirmHtml({ dataItem: row.original }),
        size: 200,
        _colName: null, // always visible for admin/manager
      });
    }

    // When columns prop is set, filter to only those columns
    if (columns.length === 0) return allColumnDefs;

    return allColumnDefs.filter(
      (col) => col._colName === null || columns.includes(col._colName)
    );
  }, [columns]);

  /* hook to reload list */
  useEffect(() => {
    if (reloadReservationList) {
      getAllReservationList();
      setReloadReservationList(false);
    }
  }, [reloadReservationList]);
  /* ---- hook to reload list on refresh ----- */
  useEffect(() => {
    if (reloadRefresh) {
      getAllReservationList();
      setReloadRefresh(false);
    }
  }, [reloadRefresh]);
  /*------ use effect for search -------*/
  useEffect(() => {
    if (
      searchReserveDate != "" ||
      searchReserveIdList.length > 0 ||
      searchReserveAmbIdList.length > 0 ||
      searchReserveActivity.length > 0 ||
      searchReserveLabels.length > 0 ||
      searchReserveBenificiaries.length > 0 ||
      searchReserveClients.length > 0 ||
      searchReserveExcludeClients.length > 0 ||
      searchReserveEducators.length > 0 ||
      searchReserveStatus.length > 0 ||
      isConsecutiveReserveFilter ||
      unsentMailReserveFilter
    ) {
      getAllReservationList();
    }
  }, [
    searchReserveDate,
    searchReserveIdList,
    searchReserveAmbIdList,
    searchReserveActivity,
    searchReserveLabels,
    searchReserveBenificiaries,
    searchReserveClients,
    searchReserveExcludeClients,
    searchReserveEducators,
    searchReserveStatus,
    isConsecutiveReserveFilter,
    unsentMailReserveFilter,
  ]);
  /* hook to hit exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);
  useEffect(() => {
    if (columns.length > 0) {
      setSearchContainerClass("rearrangeColumn");
    }
  }, [columns]);

  useEffect(() => {
    setRecords(reservationList.length);
  }, [reservationList]);

  /* Reset selected count when reservation list changes */
  useEffect(() => {
    setRowSelection({});
    checkedRecordCount(0);
  }, [reservationList]);

  // Memoize the heavy table so that GlobalContext changes which don't affect
  // the table (e.g. setEditReserveData, notifications, popups) don't trigger
  // MRT reconciliation and row re-renders.
  const tableContent = useMemo(
    () => (
      <div className={`table-responsive mt-3 ${searchContainerClass}`}>
        <MaterialReactTable
          {...appMRTProps}
          columns={tableColumns}
          data={reservationList}
          enableSorting
          enableFilters
          enableGlobalFilter={false}
          enableColumnFilterModes={false}
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          // enableRowVirtualization
          // rowVirtualizerOptions={{ overscan: 5 }}
          onRowSelectionChange={setRowSelection}
          state={{ rowSelection, isLoading: isReserveListLoading }}
          muiCircularProgressProps={{ style: { display: "none" } }}
          getRowId={(row) => row._id}
          muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
          muiTableHeadCellProps={{ title: "" }}
          initialState={{
            pagination: { pageSize: 100, pageIndex: 0 },
            showColumnFilters: true,
          }}
        />
      </div>
    ),
    // Only re-render MRT when data or display state actually changes.
    // Setter functions (setRowSelection etc.) are stable references from useState.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      appMRTProps,
      tableColumns,
      reservationList,
      rowSelection,
      isReserveListLoading,
      screenHeight,
      searchContainerClass,
    ]
  );

  return (
    <>
      {/* Hidden checkboxes so AddLabel can detect selected rows via filtername="selectedrecord" */}
      <div style={{ display: "none" }}>
        {reservationList.map((reservation) => (
          <input
            key={reservation._id}
            type="checkbox"
            filtername="selectedrecord"
            value={reservation._id}
            checked={!!rowSelection[reservation._id]}
            onChange={() => {}}
          />
        ))}
      </div>
      {defaultDateRange && (
        <div className="d-flex align-items-center gap-2 px-1 mb-1 text-muted small">
          <i className="bi bi-calendar-range"></i>
          <span>
            {t("Showing events from")}{" "}
            <strong>{defaultDateRange.start.split("-").reverse().join("-")}</strong>{" "}
            {t("to")}{" "}
            <strong>{defaultDateRange.end.split("-").reverse().join("-")}</strong>
          </span>
        </div>
      )}
      {tableContent}

      {/* View reserve data modal on click */}
      <ViewReserveModal viewReserveData={viewReserveData} />
    </>
  );
};
export default ReservationList;
